import { styled } from '@linaria/react';

function Arrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47"
      height="24"
      fill="none"
      viewBox="0 0 47 24"
    >
      <path
        fill="#fd3"
        d="M.94 10.94a1.5 1.5 0 000 2.12l9.545 9.547a1.5 1.5 0 102.122-2.122L4.12 12l8.486-8.485a1.5 1.5 0 10-2.122-2.122L.94 10.94zM2 13.5h33v-3H2v3z"
      />
      <path
        stroke="#fd3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M30 12h10.5a5 5 0 005-5V1.5"
      />
    </svg>
  );
}

function Indicator() {
  return (
    <Wrapper>
      <Text>Drag me!</Text>
      <Arrow></Arrow>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  animation: point 4000ms infinite cubic-bezier(0.5, 0, 0.5, 1);
  color: #fd3;

  @keyframes point {
    0% {
      transform: translateX(10px);
    }
    15% {
      transform: translateX(0px);
    }
    25% {
      transform: translateX(5px);
    }
    35% {
      transform: translateX(0px);
    }
    55% {
      transform: translateX(10px);
    }
    100% {
      transform: translateX(10px);
    }
  }
`;

const Text = styled.span`
  display: block;
  transform: translateX(10px);
`;

export default Indicator;
